module.exports = "mutation Like ($slug: String!, $type: String = \"campaign\") {\n  like (slug: $slug, type: $type)\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Like.graphql
// module id = 1863
// module chunks = 1610